import { Component } from '@angular/core';

@Component({
  selector: 'pgs-component',
  templateUrl: './pgs-toast.component.html',
  styleUrls: ['./pgs-toast.component.scss']
})
export class PgsToastComponent {

  constructor() { }
}
